import { useEffect, useState } from 'react'
import { useNavigate, useParams } from "react-router-dom"
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'

import Modal from '../../components/Modal/Modal'

import getAllProfessionals from '../../services/professionals/getAllProfessionals'
import getProfessionalById from '../../services/professionals/getProfessionalById'
import postProfessional from '../../services/professionals/postProfessional'
import putProfessional from '../../services/professionals/putProfessional'

import styles from './NewProfessional.module.css'

const NewProfessional = () => {

    let navigate = useNavigate()

    const { id } = useParams()
    const [ professionals, setProfessionals ] = useState([])
    const [ newProfessional, setNewProfessional ] = useState({})
    const [ active, setActive ] = useState(true)
    const [ error, setError ] = useState("")
    const [ disable, setDisable ] = useState(true)
    const [ editPassword, setEditPassword ] = useState(false)

    useEffect(() => {
        getAllProfessionals()
        .then(professionals => {
            setProfessionals(professionals);
        })

        if (id !== undefined) {
            getProfessionalById(id)
            .then(professional => {
                setNewProfessional(professional)
                setActive(professional.professionalActive)
            })
        }
    },[id])

    const generateRandomCode = () => {
        const digits = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
        const letters = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + String.fromCharCode(65 + Math.floor(Math.random() * 26))
        return digits + letters
    }

    const generateUniqueTelegramVerify = () => {
        let newId
        do {
            newId = generateRandomCode()
        } while (professionals.some(professional => professional.professionalTelegramVerify === newId))
        return newId
    };
    
    const handleEditPasswordChange = (event) => {
        setEditPassword(event.target.checked)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        const form = event.target
        const formData = new FormData(form)
        formData.append('professionalActive', event.target.professionalActive.checked)
        formData.append('professionalCompany', LocalStorage.getItem("professionalCompany"))
        formData.append('professionalServei', LocalStorage.getItem("professionalServei"))
        if (editPassword === false && id !== undefined) {
            formData.delete('professionalPassword')
        }
        if (id === undefined) {
            formData.append('professionalTelegramVerify', generateUniqueTelegramVerify())
        }
        const formJson = Object.fromEntries(formData.entries())
        if (id !== undefined) {
            putProfessional(formJson, id) 
            .then(newProfessional => {
                setNewProfessional(newProfessional)
            })
        } else {
            postProfessional(formJson) 
            .then(newProfessional => {
                setNewProfessional(newProfessional);
            })
        }
        setDisable(false)
        setTimeout(() => {
            setDisable(true)
            navigate("/professionals", { replace: true })
        },3000)
    }

    const handleChange = (event) => {
        if (event.target.id === "professionalActive") {
            setActive(event.target.checked)
        } else {
            setNewProfessional(event.target.value)
        }
    }

    return (
        <div className={styles.container}>
            <h2>{id ? "Editar professional" : "Alta nou professional"}</h2>
            <div className={disable && styles.disable}>
                <Modal error={error} id={id} text={id ? "Professional modificat correctament" : "Professional creat correctament"}></Modal>
            </div>
            <form onSubmit={handleSubmit}>
                <label for="professionalName">Nom</label>
                <input type='text' onChange={handleChange} name="professionalName" value={newProfessional.professionalName}></input>
                <label for="professionalLastName1">Cognom 1</label>
                <input type='text' onChange={handleChange} name="professionalLastName1" value={newProfessional.professionalLastName1}></input>
                <label for="professionalLastName2">Cognom 2</label>
                <input type='text' onChange={handleChange} name="professionalLastName2" value={newProfessional.professionalLastName2}></input>
                <label for="professionalDNI">DNI</label>
                <input type='text' onChange={handleChange} name="professionalDNI" value={newProfessional.professionalDNI}></input>
                <label for="professionalEmail">E-mail</label>
                <input type='email' onChange={handleChange} name="professionalEmail" value={newProfessional.professionalEmail}></input>
                { id ? (
                    <>
                        <label htmlFor="professionalPassword">Editar Password</label>
                        <input type='checkbox' onChange={handleEditPasswordChange} name="professionalPassword" checked={editPassword} className={styles.checking}></input>                
                            { 
                                editPassword && (
                                    <>
                                        <label htmlFor="professionalPassword">Password</label>
                                        <input type='password' onChange={handleChange} name="professionalPassword" placeholder='*************'></input>
                                    </>
                                )
                            }
                    </> ) : (
                        <>
                            <label for="professionalPassword">Password</label>
                            <input type='password' onChange={handleChange} name="professionalPassword" value={newProfessional.professionalPassword}></input>
                        </>
                    )
                }
                <label htmlFor="professionalTelegramVerify">Codi</label>
                <input type='text' onChange={handleChange} name="professionalTelegramVerify" value={newProfessional.professionalTelegramVerify} disabled></input>
                <label for="professionalTelegramId">Id Telegram</label>
                <input type={LocalStorage.getItem("professionalProfile") !== "Superadministrador" ? 'password' : 'text'} onChange={handleChange} name="professionalTelegramId"  value={newProfessional.professionalTelegramId} disabled></input>
                <label for="professionalProfile">Perfil</label>
                <select onChange={handleChange} name="professionalProfile" value={newProfessional.professionalProfile} id="professionalProfile">
                    <option value="selecciona" disabled>- Selecciona -</option>
                    <option value="Administrador">Administrador</option>
                    <option value="Tècnic">Tècnic</option>
                    {
                        LocalStorage.getItem("professionalProfile") === "Superadministrador" && <option value="Bot">Bot</option>
                    }
                    {
                        LocalStorage.getItem("professionalProfile") === "Superadministrador" && <option value="Superadministrador">Superadministrador</option>
                    }
                </select>
                <label for="professionalActive">Actiu</label>
                <input type='checkbox' onChange={handleChange} name="professionalActive" id="professionalActive" checked={active} className={styles.checking} />
                <div className={styles.btn_container}>
                    <button className={styles.btn_add} type='submit'>{id ? <i className="fa-regular fa-floppy-disk"></i> : <i className="fa-solid fa-circle-plus"></i>}{id ? "Guardar" : "Crear"}</button>
                </div>
            </form>
        </div>
    )
}

export default NewProfessional